import {Bell} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const NotificationsIcon = createLucideIcon(Bell, 'NotificationsIcon');
